import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { generateReceipt } from "../lib/receipt";
import { toast } from "sonner";

export default function PayPalReturn({ kind }) {
    const [params] = useSearchParams();
    const [status, setStatus] = useState(kind === "cancel" ? "cancelled" : "capturing");
    const orderId = params.get("order_id");

    useEffect(() => {
        if (kind === "cancel" || !orderId) return;
        (async () => {
            try {
                const { data } = await api.post(`/paypal/capture/${orderId}`);
                if (data.captured) {
                    setStatus("paid");
                    try {
                        const [order, settings] = await Promise.all([
                            api.get(`/orders/${orderId}`).then(r => r.data),
                            api.get("/settings").then(r => r.data),
                        ]);
                        await generateReceipt(order, settings);
                        toast.success("Recibo descargado");
                    } catch (err) { console.warn("[paypal-return] receipt download failed:", err?.message || err); }
                } else { setStatus("error"); }
            } catch (err) { console.error("[paypal-return] order finalization failed:", err?.message || err); setStatus("error"); }
        })();
    }, [orderId, kind]);

    const isSuccess = status === "paid";
    const isLoading = status === "capturing";

    return (
        <div className="max-w-2xl mx-auto px-6 py-24 text-center fade-in">
            {isLoading && <Loader2 className="w-12 h-12 text-[var(--tb-gold)] animate-spin mx-auto mb-6" />}
            {isSuccess && <CheckCircle2 className="w-16 h-16 text-[#4CAF50] mx-auto mb-6" />}
            {!isLoading && !isSuccess && <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />}
            <h1 className="font-display text-4xl mb-4">
                {isLoading ? "Verificando pago PayPal..." :
                    isSuccess ? "¡Pago PayPal Confirmado!" :
                    status === "cancelled" ? "Pago cancelado" : "Pago no completado"}
            </h1>
            <p className="text-[var(--tb-text-2)] mb-8">
                {isSuccess ? "Tu pago fue procesado correctamente. Te enviaremos la confirmación." :
                    "Si fue un error, vuelve al carrito e inténtalo de nuevo."}
            </p>
            <Link to="/perfil?tab=ordenes" className="tb-btn-primary inline-block" data-testid="paypal-orders-link">Ver mis pedidos</Link>
        </div>
    );
}
